import { Observable, Subject } from 'rxjs';

import { RuleEvent, RuleAction } from '@app/models/rules';

export class RuleValidator {
    
    isValid(rule: RuleEvent) : boolean {
        return rule.name != "" && rule.key != "" && rule.actions.length > 0;
    }
}